<script lang="ts">
  import Annotation from "../atoms/Annotation.svelte";
  import Checkboxes from "../atoms/forms/Checkboxes.svelte";
  import { initFileUploadValue } from "../atoms/forms/FileUpload";
  import FileUpload from "../atoms/forms/FileUpload/FileUpload.svelte";
  import { initImageUploadValue } from "../atoms/forms/ImageUpload";
  import ImageUpload from "../atoms/forms/ImageUpload/ImageUpload.svelte";
  import MultiSelect from "../atoms/forms/MultiSelect.svelte";
  import Select from "../atoms/forms/Select.svelte";
  import Textarea from "../atoms/forms/Textarea.svelte";
  import TextInput from "../atoms/forms/TextInput.svelte";
  import { ErrorService } from "../services/error.service";
  export let label = undefined;
  export let annotation = undefined;
  export let inputType = "text";
  export let value: string | number = "";
  export let file = initFileUploadValue();
  export let image = initImageUploadValue();
  export let placeholder = "";
  export let klass = "";
  export let isError = false;
  export let min = undefined;
  export let max = undefined;
  export let options = [];
  export let values = [];
  export let disabled = false;
  export let input = (event) => {
    ErrorService.unimplemented();
  };
</script>

{#if label}
  <div class="text-sm font-medium mb-2">
    {label}
  </div>
{/if}

{#if annotation}
  <Annotation klass="mb-1">
    {annotation}
  </Annotation>
{/if}

{#if inputType === "textarea"}
  <Textarea {value} {placeholder} on:input={input} {klass} {isError} />
{:else if inputType === "number"}
  <TextInput
    {value}
    {inputType}
    {placeholder}
    on:input={input}
    {klass}
    {isError}
    {min}
    {max}
    {disabled}
  />
{:else if inputType === "image"}
  <ImageUpload value={image} on:input={input} {klass} />
{:else if inputType === "file"}
  <FileUpload value={file} on:input={input} {klass} />
{:else if inputType === "select"}
  <Select {value} on:input={input} {klass} {options} {disabled} />
{:else if inputType === "multiSelect"}
  <MultiSelect {values} on:input={input} {klass} {options} />
{:else if inputType === "checkboxes"}
  <Checkboxes {values} on:click={input} {klass} {options} />
{:else}
  <TextInput
    {value}
    {inputType}
    {placeholder}
    on:input={input}
    {klass}
    {isError}
    {disabled}
  />
{/if}
